const transition = require('transition-to-from-auto');

/*@ngInject*/
const UIViewportManagerDirective = function ($window, $rootScope, $timeout, formViewerConstant, uiPerformanceLoggerConstant, coreConstant,
                                             formRenderingUtil, watchManagerUtil, timingModel, formComponentRenderingUtil, formatUtil, umsLog) {

    let linkFunction = function ($scope, $elm) {

        let timeoutList = [],
            element = $($elm),
            parentElement = element.parent();

        function handleScroll (event) {
            let target = event.target,
                isScrollable = target.scrollHeight > target.clientHeight;

            $scope.showLazyLoadingSpinner = isScrollable && $scope.isRendering && !$scope.isLoading;
            watchManagerUtil.updateView();
            timeoutList.push($timeout(function () {}, 0));
        }

        function optimizeFormWatchers () {
            // timeout to ensure row repeaters are on the screen prior to selecting components
            // check to see if this can be removed after components are all manually created
            // by formRenderingComponentUtil
            timeoutList.push($timeout(function () {
                let fieldListComponents = parentElement.find('.fieldListComponent');
                watchManagerUtil.setupScope(parentElement, fieldListComponents);
                watchManagerUtil.updateView();
            }, 200));
        }

        function triggerFormReadyPerformanceLogger () {
            let logAction = uiPerformanceLoggerConstant.SHOW_FORM,
                status = coreConstant.uiPeformanceLogger.SUCCESS;

            $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, logAction, status);
        }

        function beginBuildingForm (formData) {
            $scope.isLoading = true;
            $scope.isRendering = true;

            clearExistingForm();

            formRenderingUtil.registerWatcherCallback(optimizeFormWatchers);
            formRenderingUtil.registerInitialRenderingCompleteCallback(initialScreenRendered);
            formRenderingUtil.registerFadeInRenderedSectionsCallback(fadeInRenderedSections);
            formRenderingUtil.beginRendering(element, formData).then(function () {
                let totalRenderTime;

                $scope.isRendering = false;

                $timeout(function () {
                    timingModel.addMilestone(formViewerConstant.timing.FORM_VIEWER, formViewerConstant.timing.FORM_FULLY_RENDERED);
                    totalRenderTime = timingModel.getDuration(formViewerConstant.timing.FORM_VIEWER, formViewerConstant.timing.BEGIN_RENDERING, formViewerConstant.timing.FORM_FULLY_RENDERED);
                    $($elm).addClass('renderedInFull');
                    console.log($scope.formData.formName + ':totalRenderTime: ' + totalRenderTime);
                }, 1);
            });
        }

        function clearExistingForm () {
            let formName = _.get($scope, 'formData.formName'),
                sections = _.get($scope, 'formData.sectionList');

            formComponentRenderingUtil.resetAllSections(parentElement, formName, $scope.formId, sections);
        }

        function initialScreenRendered () {
            let networkRequests,
                initialViewRendering;

            $timeout(function () {
                $scope.isLoading = false;
                timingModel.addMilestone(formViewerConstant.timing.FORM_VIEWER, formViewerConstant.timing.INITIAL_SCREEN_RENDERED);

                networkRequests = timingModel.getDuration(formViewerConstant.timing.FORM_VIEWER, formViewerConstant.timing.LOAD_DATA, formViewerConstant.timing.BEGIN_RENDERING);
                initialViewRendering = timingModel.getDuration(formViewerConstant.timing.FORM_VIEWER, formViewerConstant.timing.BEGIN_RENDERING, formViewerConstant.timing.INITIAL_SCREEN_RENDERED);

                console.log($scope.formData.formName + ':networkRequests: ' + networkRequests);
                console.log($scope.formData.formName + ':initialViewRendering: ' + initialViewRendering);

                triggerFormReadyPerformanceLogger();
                $($elm).addClass('rendered');
            }, 1);
        }

        function fadeInRenderedSections () {
            timeoutList.push($timeout(function () {
                let elementsToFadeIn = element.find('.formSection.rendering');
                elementsToFadeIn.removeClass('rendering');
            }, 5));
        }

        function configure () {
            parentElement.on('scroll', handleScroll);

            $scope.$on(formViewerConstant.event.FORM_DATA_READY, function (event, formData, rootFormId) {
                if ($scope.formId === rootFormId && !$scope.isRendering) {
                    beginBuildingForm(formData);
                }
            });

            /*
             * A field can have its value updated by the server, which can change
             * how its component is displayed, and so change the height of its row.
             * For example, a yes-no component can show or hide a text box depending
             * on the field's value. If the text box is hidden, and the row's height
             * is reduced, that could cause additional rows to come into view that
             * were not visible before. The components of those additional rows have
             * their watchers disabled (because they had been offscreen), so they
             * might not be displayed correctly. So call updateView to reevaluate
             * the watcher situation.
             */
            $scope.$on(formViewerConstant.event.UPDATE_FIELD_MESSAGE,
                function (event) {
                    $timeout(function () {
                            watchManagerUtil.updateView();
                        },
                        0);
                });

            $scope.$on(formViewerConstant.event.SUPPLEMENTAL_FORM_ADDED, function (event, supplementalFormName, supplementalFormRootStructure) {
                var parentFormName = formatUtil.formatAsSelector(supplementalFormRootStructure.uiFormTemplate.precedingFieldFormTemplateUniqueName),
                    rootFormId = supplementalFormRootStructure.formModel.rootFormId,
                    maxTryCount = 5,
                    currentTryCount = 0;

                function insertSupplementalForm () {
                    let precedingFieldName = formatUtil.formatAsSelector(supplementalFormRootStructure.uiFormTemplate.precedingFieldVariableName);
                    let precedingRow = $('.' + parentFormName + ' .formRow:has(.formFieldComponent-' + precedingFieldName + ')');
                    let isPrecedingRowRepeating = !_.isNil(precedingRow) && precedingRow.length > 1;

                    if(precedingRow.length) {
                        if (isPrecedingRowRepeating) {
                            precedingRow = precedingRow[ 0 ];
                        }

                        if (parseInt($scope.formId) === rootFormId) {
                            formRenderingUtil.insertSupplemental(precedingRow, supplementalFormRootStructure).then(function () {
                                optimizeFormWatchers();
                                timeoutList.push($timeout(function () {

                                    transition({
                                        element: '.' + supplementalFormName,
                                        prop: 'height',
                                        val: 'auto',
                                        style: 'height .35s ease-out'
                                    });

                                }, 1));
                            });
                        }
                    }
                    else {
                        if(currentTryCount < maxTryCount) {
                            $timeout(() => {
                                currentTryCount += 1;
                                insertSupplementalForm();
                            }, 500);
                        }
                        else {
                            umsLog.error('Unable to find preceding row when adding supplemental');
                        }
                    }
                }

                insertSupplementalForm();

            });

            $scope.$on(formViewerConstant.event.REPEATING_ROW_PAGE_CHANGE, function () {
                optimizeFormWatchers();
            });

            $scope.$on(formViewerConstant.event.OPTIMIZE_FORM_WATCHERS, function () {
                optimizeFormWatchers();
            });

            $scope.$on(formViewerConstant.event.SUPPLEMENTAL_FORM_REMOVED, function (event, supplementalFormName, rootFormId, supplementalFormId, sectionList) {
                const supplementalFormContainer = $('.' + supplementalFormName);
                const supplementalParentContainer = $(supplementalFormContainer.parents('.formViewer')[1]);
                const supplementalFormRowContainer = $(supplementalFormContainer.parents('.formRow')[0]);

                if (parseInt($scope.formId) === rootFormId) {
                    transition({
                        element: '.' + supplementalFormName,
                        prop: 'height',
                        val: '0',
                        style: 'height .35s ease-out'
                    });

                    supplementalFormContainer.addClass('isHidden');

                    $('.' + supplementalFormName + ':parent').css('margin', '0px');

                    $timeout(function () {
                        formComponentRenderingUtil.resetAllSections(supplementalParentContainer, supplementalFormName, supplementalFormId, sectionList, true);
                        supplementalFormRowContainer.remove();
                    }, 350);
                }
            });

            $scope.$on(formViewerConstant.configuration.event.CREATE_NEW_ROW, function (event, newRowConfiguration) {
                formRenderingUtil.insertNewRow(newRowConfiguration);
            });

            $scope.$on(formViewerConstant.configuration.event.CREATE_NEW_COMPONENT, function (event, newComponentConfiguration) {
                formRenderingUtil.insertNewComponent(newComponentConfiguration);
            });

            $scope.$on(formViewerConstant.configuration.event.CREATE_NEW_SECTION, function (event, newSectionConfiguration) {
                formRenderingUtil.insertNewSection(newSectionConfiguration);
            });

            $scope.$on(formViewerConstant.configuration.event.CREATE_NEW_ROW_REPEATER, function (event, newRowRepeaterConfiguration) {
                formRenderingUtil.insertNewRowRepeater(newRowRepeaterConfiguration);
            });

            $scope.$on(formViewerConstant.configuration.event.UPDATE_COMPONENT_SETTING, function (event, fieldStructure) {
                let component = $('.' + fieldStructure.fieldStructureId),
                    parentRow = component.parent(),
                    totalChildrenInRow = parentRow.children().length,
                    previousSibling = component.prev(),
                    nextSibling = component.next(),
                    hasPreviousSibling = previousSibling.length > 0,
                    hasNextSibling = nextSibling.length > 0;

                component.remove();

                if (totalChildrenInRow === 1) {
                    formRenderingUtil.createConfigurableComponent(fieldStructure, parentRow);
                }
                else if (hasPreviousSibling) {
                    formRenderingUtil.createConfigurableComponentAfter(fieldStructure, previousSibling);
                }
                else if (hasNextSibling) {
                    formRenderingUtil.createConfigurableComponentBefore(fieldStructure, nextSibling);
                }
            }.bind(this));

            $scope.$on(formViewerConstant.configuration.event.UPDATE_ROW_REPEATER_SETTING, function (event, rowStructure) {
                let component = $('.' + rowStructure.rowStructureId),
                    parentSection = component.parent(),
                    previousSibling = component.prev(),
                    nextSibling = component.next(),
                    hasPreviousSibling = previousSibling.length > 0,
                    hasNextSibling = nextSibling.length > 0;

                component.remove();

                if (hasPreviousSibling) {
                    formRenderingUtil.createConfigurableRowRepeaterComponentAfter(rowStructure, previousSibling);
                }
                else if (hasNextSibling) {
                    formRenderingUtil.createConfigurableRowRepeaterComponentBefore(rowStructure, nextSibling);
                }
                else {
                    formRenderingUtil.createConfigurableRowRepeaterComponent(rowStructure, parentSection);
                }
            }.bind(this));

            function beforePrint() {
                const fakeParentViewport = parentElement.find('.formName');
                const fieldListComponents = $('.fieldListComponent');
                watchManagerUtil.setupScope(fakeParentViewport, fieldListComponents);
                watchManagerUtil.updateView();
            }

            function afterPrint() {
                optimizeFormWatchers();
            }

            $window.addEventListener('beforeprint', beforePrint);
            $window.addEventListener('afterprint', afterPrint);

            $scope.$watch('formId', function (newValue, oldValue) {
                if (oldValue && newValue !== oldValue) {
                    clearExistingForm();
                }
            });

            $scope.$on('$destroy', function () {
                parentElement.off('scroll', handleScroll);
                clearExistingForm();

                _.each(timeoutList, function (timeout) {
                    $timeout.cancel(timeout);
                });

                $window.removeEventListener('beforeprint', beforePrint);
                $window.removeEventListener('afterprint', afterPrint);
            });
        }

        if (!$scope.supplemental) {
            configure();
        }
        else {
            formRenderingUtil.renderSupplemental(element, $scope.formData);
        }
    };

    return {
        restrict: 'A',
        link: linkFunction
    };
};

angular.module('umFormViewer')
    .directive('uiViewportManager', UIViewportManagerDirective);
